module.exports = __webpack_public_path__ + "img/ai-img-douyin-bg.34e3ec86.png";